import { useLocalStorageState } from "../hooks/useLocalStorageState";
import { useFetchWeather } from "../hooks/useFetchWeather";
import Input from "./Input";
import Weather from "./Weather";
import ErrorMessage from "../static components/ErrorMessage";
import Loader from "../static components/Loader";

export default function App() {
  const [location, setLocation] = useLocalStorageState("", "location");
  const { displayLocation, weather, isloading, error } =
    useFetchWeather(location);

  function handleSetLocation(e) {
    setLocation(e.target.value);
  }

  return (
    <div className="app">
      <h1>Classy weather</h1>
      <Input location={location} onChangeLocation={handleSetLocation} />
      {isloading && <Loader />}
      {error && <ErrorMessage message={error} />}
      {!isloading && !error && weather.weathercode && (
        <Weather weather={weather} displayLocation={displayLocation} />
      )}
    </div>
  );
}
